import state from './emailState';
import mutations from './emailMutations';
import actions from './emailActions';
import getters from "./emailGetters";

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}